import {useComputed} from "@preact/signals-react";
import {useCallback} from "react";

import { adminProductReviewItemClicked, adminProductReviewDetailsClicked, adminProductReviewEditClicked, adminProductReviewLoadingRow } from "../@signals";

export default function useAdminProductReviewTable(rowData) {
	const rowItemClicked = useComputed(() => adminProductReviewItemClicked.value === rowData.key)
	const rowDetailsClicked = useComputed(() => adminProductReviewDetailsClicked.value === rowData.key)
	const rowEditClicked = useComputed(() => adminProductReviewEditClicked.value === rowData.key)
	const rowIsLoading = useComputed(() => adminProductReviewLoadingRow.value.includes(rowData.key))

	const handleItemsRowClick = useCallback(() => {
		adminProductReviewItemClicked.value = rowData.key
	}, [JSON.stringify(rowData.key)])

	const handleDetailsRowClick = useCallback(() => {
		adminProductReviewDetailsClicked.value = rowData.key
	}, [JSON.stringify(rowData.key)])

	const handleEditRowClick = useCallback(() => {
		adminProductReviewEditClicked.value = rowData.key
	}, [JSON.stringify(rowData.key)])

	return {
		rowItemsClicked: rowItemClicked.value,
		rowDetailsClicked: rowDetailsClicked.value,
		rowEditClicked: rowEditClicked.value,
		rowIsLoading: rowIsLoading.value,
		handleItemsRowClick,
		handleDetailsRowClick,
		handleEditRowClick
	}
}